import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MIRROR_URL = `${process.env.REACT_APP_BACKEND_URL}`;

// ─── DONNÉES AGENTS ───────────────────────────────────────────────
const AGENTS_DATA = [
  {
    id: 'jade',
    nom: 'JADE',
    icone: '✈',
    pole: 'Voyage Philippines/SEA',
    role: 'Agent Voyage & Tourisme SEA',
    llm: 'gemini-pro',
    temp: 0.45,
    couleur: '#ffd700',
    bg: '#1a1500',
    border: '#3d3000',
    status: 'ACTIVE',
    apis: ['AviationStack', 'Google Maps', 'Booking'],
    description: 'Planification voyages Philippines/SEA, réservations, itinéraires personnalisés.',
    prix: 'Tier BUSINESS 697€/mois',
  },
  {
    id: 'lexa',
    nom: 'LEXA',
    icone: '⚖',
    pole: 'Juridique/Fiscal PME',
    role: 'Agent Juridique & Fiscal PME',
    llm: 'gemini-pro',
    temp: 0.35,
    couleur: '#00ff88',
    bg: '#001a0d',
    border: '#003d1a',
    status: 'ACTIVE',
    apis: ['LegiFrance', 'EUR-Lex'],
    description: 'Analyse contrats, fiscalité PME, veille juridique, compliance RGPD.',
    prix: 'Tier BUSINESS 697€/mois',
  },
  {
    id: 'clara',
    nom: 'CLARA',
    icone: '€',
    pole: 'Support client',
    role: 'Agent Support Client',
    llm: 'gemini-flash',
    temp: 0.40,
    couleur: '#4488ff',
    bg: '#00081a',
    border: '#001a3d',
    status: 'ACTIVE',
    apis: ['Stripe', 'CoinGecko', 'ECB Rates'],
    description: 'Support client, onboarding, fidélisation.',
    prix: 'post-1er-client',
  },
  {
    id: 'studio',
    nom: 'STUDIO',
    icone: '✦',
    pole: 'Création Visuelle',
    role: 'Agent Créatif & Visuel',
    llm: 'gemini-flash',
    temp: 0.70,
    couleur: '#ff8800',
    bg: '#1a0d00',
    border: '#3d2000',
    status: 'ACTIVE',
    apis: ['ComfyUI', 'Unsplash', 'Canva'],
    description: 'Génération images, branding, contenu visuel IA.',
    prix: 'post-démo',
  },
  {
    id: 'athena',
    nom: 'ATHENA',
    icone: '◈',
    pole: 'Marketing/Branding',
    role: 'Chef de Pôle Marketing',
    llm: 'gemini-flash',
    temp: 0.65,
    couleur: '#cc44ff',
    bg: '#0f0015',
    border: '#2a0040',
    status: 'ACTIVE',
    apis: ['Google Analytics', 'Meta Ads', 'Brevo'],
    description: 'Stratégie marketing, campagnes, brand, analytics. Coordonne le pôle marketing.',
    prix: 'Tier BUSINESS 697€/mois',
  },
  {
    id: 'atlas',
    nom: 'ATLAS',
    icone: '◎',
    pole: 'Sales/Négociation',
    role: 'Agent Sales & Négociation',
    llm: 'gemini-pro',
    temp: 0.55,
    couleur: '#ff8844',
    bg: '#1a0800',
    border: '#3d1500',
    status: 'ACTIVE',
    apis: ['HubSpot', 'Hunter.io', 'Stripe'],
    description: 'Stratégie commerciale, pipeline CRM, prospection, closing, revenue.',
    prix: 'Tier BUSINESS 697€/mois',
  },
  {
    id: 'jardin',
    nom: 'JARDIN',
    icone: '✿',
    pole: 'Créatif souverain',
    role: 'Agent Créatif Souverain',
    llm: 'dolphin-local',
    temp: 0.70,
    couleur: '#ff44aa',
    bg: '#1a0010',
    border: '#3d0025',
    status: 'ACTIVE',
    apis: ['ComfyUI', 'TTS Local'],
    description: 'Contenu créatif sans filtre. Accès réservé admin.',
    prix: 'Token JWT dédié',
    adminOnly: true,
  },
  {
    id: 'selena',
    nom: 'SELENA',
    icone: '⚡',
    pole: 'Coordination Générale',
    role: 'Agent Coordinateur Central',
    llm: 'groq-dncm',
    temp: 0.5,
    couleur: '#ff2222',
    bg: '#1a0000',
    border: '#3d0000',
    status: 'ACTIVE',
    apis: ['LiteLLM', 'PostgreSQL'],
    description: 'Coordinateur central de tous les agents DNCM.',
    prix: 'Inclus',
  },
  {
    id: 'aria',
    nom: 'ARIA',
    icone: '🎙',
    pole: 'Standardiste Vocale',
    role: 'Agent Accueil & Orientation',
    llm: 'gemini-dncm',
    temp: 0.7,
    couleur: '#00aaff',
    bg: '#001a2a',
    border: '#003d5a',
    status: 'ACTIVE',
    apis: ['TTS', 'Webhook'],
    description: 'Accueil vocal 24h/24, orientation clients, premier contact DNCM.',
    prix: 'Tier STARTER 97€/mois',
  },
  {
    id: 'nova',
    nom: 'NOVA',
    icone: '📞',
    pole: 'Standardiste IA',
    role: 'Agent Vocal Trilingue',
    llm: 'gemini-dncm',
    temp: 0.7,
    couleur: '#00ffcc',
    bg: '#001a15',
    border: '#003d30',
    status: 'ACTIVE',
    apis: ['TTS Local', 'Webhook'],
    description: 'Standardiste vocale FR/EN/Tagalog, reception appels 24h/24.',
    prix: 'Tier STARTER 97€/mois',
  },
  {
    id: 'neo',
    nom: 'NEO',
    icone: '💻',
    pole: 'Developpement IA',
    role: 'Agent Tech & Automatisation',
    llm: 'cerebras-dncm',
    temp: 0.3,
    couleur: '#44ff44',
    bg: '#001a00',
    border: '#003d00',
    status: 'ACTIVE',
    apis: ['GitHub', 'N8N', 'Docker'],
    description: 'Developpement, automatisation, integrations techniques DNCM.',
    prix: 'Tier BUSINESS 297€/mois',
  },
  {
    id: 'vega',
    nom: 'VEGA',
    icone: '✍',
    pole: 'Copywriting & Contenu',
    role: 'Agent Redaction & Marketing',
    llm: 'gemini-dncm',
    temp: 0.8,
    couleur: '#ff8800',
    bg: '#1a0e00',
    border: '#3d2000',
    status: 'ACTIVE',
    apis: ['Unsplash', 'WordPress'],
    description: 'Copywriting, articles, accroches Instagram, contenu marketing.',
    prix: 'Tier BUSINESS 297€/mois',
  },
  {
    id: 'sofia',
    nom: 'SOFIA',
    icone: '🤝',
    pole: 'RH & Recrutement',
    role: 'Agent Ressources Humaines',
    llm: 'cerebras-dncm',
    temp: 0.5,
    couleur: '#ff66cc',
    bg: '#1a0015',
    border: '#3d0030',
    status: 'ACTIVE',
    apis: ['LinkedIn', 'Brevo'],
    description: 'Recrutement, onboarding, gestion RH et suivi collaborateurs.',
    prix: 'Tier BUSINESS 297€/mois',
  },
  {
    id: 'lena',
    nom: 'LENA',
    icone: '📊',
    pole: 'Finance & Comptabilite',
    role: 'Agent Finance IA',
    llm: 'groq-dncm',
    temp: 0.3,
    couleur: '#ffdd00',
    bg: '#1a1500',
    border: '#3d3000',
    status: 'ACTIVE',
    apis: ['Stripe', 'ECB Rates', 'CoinGecko'],
    description: 'Analyse financiere, comptabilite, rapports et previsions.',
    prix: 'Tier BUSINESS 297€/mois',
  },
  {
    id: 'eva',
    nom: 'EVA',
    icone: '👁',
    pole: 'Executive Assistant',
    role: 'Agent Direction & Strategie',
    llm: 'gpt-4o-dncm',
    temp: 0.4,
    couleur: '#cc44ff',
    bg: '#15001a',
    border: '#30003d',
    status: 'ACTIVE',
    apis: ['Calendar', 'Gmail', 'Notion'],
    description: 'Assistante direction, syntheses strategiques, coordination executive.',
    prix: 'Tier ENTERPRISE 697€/mois',
  },
];

const STATUS_CONFIG = {
  ACTIVE:   { dot: '#00ff88', bg: '#003d1a', color: '#00ff88', border: '#00aa44', label: 'ACTIVE' },
  PENDING:  { dot: '#ffaa00', bg: '#1a1200', color: '#ffaa00', border: '#3d2d00', label: 'PENDING' },
  NEW:      { dot: '#4488ff', bg: '#00081a', color: '#4488ff', border: '#001a3d', label: 'À CRÉER' },
  ERROR:    { dot: '#ff2222', bg: '#1a0000', color: '#ff2222', border: '#3d0000', label: 'ERREUR' },
};

// ─── COMPOSANT CARD AGENT ─────────────────────────────────────────
function AgentCard({ agent, onClick, selected }) {
  const st = STATUS_CONFIG[agent.status] || STATUS_CONFIG.PENDING;
  return (
    <div
      onClick={() => onClick(agent)}
      style={{
        background: selected ? agent.bg : '#0a0a0a',
        border: `1px solid ${selected ? agent.couleur : '#1a1a1a'}`,
        borderRadius: '2px',
        padding: '14px 12px',
        cursor: 'pointer',
        position: 'relative',
        transition: 'border-color .15s, transform .15s',
        fontFamily: "'Courier New', monospace",
      }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = selected ? agent.couleur : '#333'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = selected ? agent.couleur : '#1a1a1a'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >
      {/* Icône + Nom */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <span style={{ fontSize: '20px', color: agent.couleur }}>{agent.icone}</span>
        <div>
          <div style={{ fontSize: '13px', fontWeight: 700, color: '#e0e0e0', letterSpacing: '.1em' }}>{agent.nom}</div>
          <div style={{ fontSize: '9px', color: '#555', letterSpacing: '.08em', textTransform: 'uppercase' }}>{agent.pole}</div>
        </div>
      </div>

      {/* LLM */}
      <div style={{ fontSize: '9px', color: '#444', fontFamily: 'monospace', marginBottom: '8px' }}>
        {agent.llm} · t={agent.temp}
      </div>

      {/* Status dot */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '10px' }}>
        <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: st.dot, display: 'inline-block' }} />
        <span style={{ fontSize: '8px', color: st.color, letterSpacing: '.1em', textTransform: 'uppercase',
          background: st.bg, border: `1px solid ${st.border}`, padding: '1px 5px', borderRadius: '1px' }}>
          {st.label}
        </span>
      </div>

      {/* API chips */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', marginBottom: '10px' }}>
        {agent.apis.slice(0, 3).map(api => (
          <span key={api} style={{
            fontSize: '7px', padding: '2px 5px', borderRadius: '1px', letterSpacing: '.06em',
            textTransform: 'uppercase', border: `1px solid ${agent.border}`,
            color: agent.couleur, background: agent.bg,
          }}>{api}</span>
        ))}
      </div>

      {/* Bouton */}
      <div style={{
        width: '100%', padding: '7px 0', textAlign: 'center', fontSize: '9px', fontWeight: 700,
        letterSpacing: '.12em', textTransform: 'uppercase', borderRadius: '1px', cursor: 'pointer',
        background: agent.bg, border: `1px solid ${agent.border}`, color: agent.couleur,
      }}>
        {selected ? 'SÉLECTIONNÉ ▲' : 'CONFIGURER →'}
      </div>
    </div>
  );
}

// ─── PANNEAU DÉTAIL AGENT ─────────────────────────────────────────
function AgentDetail({ agent, onClose }) {
  const [deploying, setDeploying] = useState(false);
  const [deploySteps, setDeploySteps] = useState([]);
  const [deployed, setDeployed] = useState(false);
  const st = STATUS_CONFIG[agent.status] || STATUS_CONFIG.PENDING;

  const STEPS = [
    'Connexion PostgreSQL',
    'Chargement persona',
    'Routing LLM configuré',
    'APIs connectées',
    'Agent opérationnel',
  ];

  const handleDeploy = () => {
    setDeploying(true);
    setDeploySteps([]);
    const delays = [400, 900, 1500, 2200, 3000];
    delays.forEach((delay, i) => {
      setTimeout(() => {
        setDeploySteps(prev => [...prev, i]);
        if (i === 4) {
          setTimeout(() => { setDeploying(false); setDeployed(true); }, 500);
        }
      }, delay);
    });
  };

  return (
    <div style={{
      background: '#0a0a0a', border: `1px solid ${agent.couleur}`,
      borderRadius: '2px', padding: '20px', fontFamily: "'Courier New', monospace",
      marginTop: '16px',
    }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ fontSize: '32px', color: agent.couleur, width: '48px', height: '48px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: agent.bg, border: `1px solid ${agent.border}`, borderRadius: '2px' }}>
            {agent.icone}
          </div>
          <div>
            <div style={{ fontSize: '18px', fontWeight: 700, color: '#e0e0e0', letterSpacing: '.12em' }}>
              AGENT {agent.nom}
            </div>
            <div style={{ fontSize: '10px', color: '#555', letterSpacing: '.08em', textTransform: 'uppercase' }}>
              {agent.role}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '4px' }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: st.dot, display: 'inline-block' }} />
              <span style={{ fontSize: '9px', color: st.color, letterSpacing: '.1em', textTransform: 'uppercase' }}>
                {st.label}
              </span>
            </div>
          </div>
        </div>
        <button onClick={onClose} style={{
          background: 'none', border: '1px solid #333', color: '#555', padding: '4px 8px',
          cursor: 'pointer', fontSize: '11px', fontFamily: "'Courier New', monospace",
        }}>✕ FERMER</button>
      </div>

      {/* Description */}
      <div style={{ fontSize: '11px', color: '#888', marginBottom: '16px', lineHeight: '1.6',
        borderLeft: `2px solid ${agent.couleur}`, paddingLeft: '10px' }}>
        {agent.description}
      </div>

      {/* Infos grille */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
        {[
          { label: 'MODÈLE LLM', val: agent.llm },
          { label: 'TEMPÉRATURE', val: agent.temp },
          { label: 'TARIF', val: agent.prix },
        ].map(item => (
          <div key={item.label} style={{ background: '#080808', border: '1px solid #1a1a1a', padding: '10px', borderRadius: '2px' }}>
            <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: '4px' }}>
              {item.label}
            </div>
            <div style={{ fontSize: '12px', color: '#e0e0e0', fontWeight: 700 }}>{item.val}</div>
          </div>
        ))}
      </div>

      {/* APIs */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontSize: '8px', color: '#ff2222', letterSpacing: '.18em', textTransform: 'uppercase',
          marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
          APIS CONNECTÉES
          <span style={{ flex: 1, height: '1px', background: '#1a1a1a', display: 'inline-block' }} />
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          {agent.apis.map(api => (
            <span key={api} style={{
              fontSize: '9px', padding: '4px 8px', borderRadius: '1px', letterSpacing: '.08em',
              textTransform: 'uppercase', border: `1px solid ${agent.border}`,
              color: agent.couleur, background: agent.bg,
            }}>{api}</span>
          ))}
        </div>
      </div>

      {/* Deploy section */}
      {!deployed ? (
        <div>
          {deploying ? (
            <div style={{ background: '#080808', border: '1px solid #1a1a1a', padding: '14px', borderRadius: '2px' }}>
              {STEPS.map((step, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                  <span style={{ fontSize: '10px',
                    color: deploySteps.includes(i) ? '#00ff88' : deploySteps.length === i ? '#ffaa00' : '#333' }}>
                    {deploySteps.includes(i) ? '✓' : deploySteps.length === i ? '▶' : '○'}
                  </span>
                  <span style={{ fontSize: '10px', letterSpacing: '.06em',
                    color: deploySteps.includes(i) ? '#00ff88' : deploySteps.length === i ? '#ffaa00' : '#333' }}>
                    {step}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <button onClick={handleDeploy} style={{
              width: '100%', padding: '11px', background: agent.couleur, color: '#000',
              border: 'none', borderRadius: '2px', fontSize: '11px', fontWeight: 700,
              letterSpacing: '.14em', textTransform: 'uppercase', cursor: 'pointer',
              fontFamily: "'Courier New', monospace",
            }}>
              ⚡ DÉPLOYER AGENT {agent.nom}
            </button>
          )}
        </div>
      ) : (
        <div style={{ background: '#001a0d', border: '1px solid #003d1a', padding: '12px', borderRadius: '2px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: '11px', color: '#00ff88', fontWeight: 700, letterSpacing: '.1em' }}>
              ✓ AGENT {agent.nom} DÉPLOYÉ · PROTECTION DNCM ACTIVE
            </div>
            <div style={{ fontSize: '9px', color: '#555', marginTop: '3px' }}>
              Endpoint: /api/{agent.id}/chat · Tenant: dncm-master
            </div>
          </div>
          <span style={{ fontSize: '9px', color: '#00ff88', background: '#003d1a',
            border: '1px solid #00aa44', padding: '3px 8px', borderRadius: '1px' }}>LIVE</span>
        </div>
      )}
    </div>
  );
}

// ─── COMPOSANT AGENT MIROIR ───────────────────────────────────────
function AgentMiroir({ token }) {
  const [onglet, setOnglet] = useState('personas');
  const [personas, setPersonas] = useState([]);
  const [loadingPersonas, setLoadingPersonas] = useState(false);
  const [form, setForm] = useState({ nom: '', role: '', description: '', pole: '', llm: 'gemini-flash', temp: 0.45 });
  const [generating, setGenerating] = useState(false);
  const [genResult, setGenResult] = useState(null);

  const loadPersonas = useCallback(async () => {
    setLoadingPersonas(true);
    try {
      const res = await axios.get(`${MIRROR_URL}/api/mirror/personas`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPersonas(res.data.personas || []);
    } catch {
      // fallback demo
      setPersonas([
        { id: 4, nom: 'CLARA', created_at: '2026-03-27T11:26:11' },
        { id: 5, nom: 'STUDIO', created_at: '2026-03-27T11:27:04' },
        { id: 6, nom: 'SELENA_BIS', created_at: '2026-03-27T11:27:47' },
        { id: 8, nom: 'ATHENA', created_at: '2026-04-02T12:31:33' },
        { id: 9, nom: 'ATLAS', created_at: '2026-04-02T12:32:21' },
      ]);
    } finally {
      setLoadingPersonas(false);
    }
  }, [token]);

  useEffect(() => { if (onglet === 'personas') loadPersonas(); }, [onglet, loadPersonas]);

  const handleGenerate = async () => {
    if (!form.nom || !form.role) return;
    setGenerating(true);
    setGenResult(null);
    try {
      const res = await axios.post(
        `${MIRROR_URL}/api/mirror/generate-persona`,
        {
          nom: form.nom,
          json_complet: {
            version: '1.0', brain: 'DNCM',
            model: form.llm, temperature: parseFloat(form.temp),
            role: form.role, description: form.description,
            pole: form.pole, niveau: 'custom',
          }
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setGenResult(res.data);
    } catch (e) {
      setGenResult({ ok: false, error: e.message });
    } finally {
      setGenerating(false);
    }
  };

  const ONGLETS = ['personas', 'générer', 'routing'];

  return (
    <div style={{
      background: '#0a0a0a', border: '1px solid #3d0000', borderRadius: '2px',
      fontFamily: "'Courier New', monospace",
    }}>
      {/* Header miroir */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #1a1a1a',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '18px', color: '#ff2222' }}>◐</span>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#e0e0e0', letterSpacing: '.1em' }}>
              AGENT MIROIR
            </div>
            <div style={{ fontSize: '9px', color: '#555', letterSpacing: '.08em', textTransform: 'uppercase' }}>
              Créez votre agent sur mesure · Port 4016
            </div>
          </div>
        </div>
        <span style={{ fontSize: '8px', color: '#00ff88', background: '#003d1a',
          border: '1px solid #00aa44', padding: '2px 7px', borderRadius: '1px' }}>ONLINE</span>
      </div>

      {/* Onglets */}
      <div style={{ display: 'flex', borderBottom: '1px solid #1a1a1a' }}>
        {ONGLETS.map(o => (
          <button key={o} onClick={() => setOnglet(o)} style={{
            padding: '9px 16px', fontSize: '9px', letterSpacing: '.12em', textTransform: 'uppercase',
            background: onglet === o ? '#1a0000' : 'none',
            color: onglet === o ? '#ff2222' : '#444',
            border: 'none', borderBottom: onglet === o ? '2px solid #ff2222' : '2px solid transparent',
            cursor: 'pointer', fontFamily: "'Courier New', monospace",
          }}>{o}</button>
        ))}
      </div>

      <div style={{ padding: '16px' }}>

        {/* ONGLET PERSONAS */}
        {onglet === 'personas' && (
          <div>
            <div style={{ fontSize: '8px', color: '#ff2222', letterSpacing: '.18em',
              textTransform: 'uppercase', marginBottom: '12px' }}>
              PERSONAS EN BASE — POSTGRESQL
            </div>
            {loadingPersonas ? (
              <div style={{ color: '#ff2222', fontSize: '11px' }}>CHARGEMENT...</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {personas.map(p => (
                  <div key={p.id} style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    background: '#080808', border: '1px solid #1a1a1a',
                    padding: '9px 12px', borderRadius: '2px',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '10px', color: '#444' }}>#{p.id}</span>
                      <span style={{ fontSize: '11px', fontWeight: 700, color: '#e0e0e0', letterSpacing: '.08em' }}>
                        {p.nom}
                      </span>
                    </div>
                    <span style={{ fontSize: '9px', color: '#444' }}>
                      {new Date(p.created_at).toLocaleDateString('fr-FR')}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ONGLET GÉNÉRER */}
        {onglet === 'générer' && (
          <div>
            <div style={{ fontSize: '8px', color: '#ff2222', letterSpacing: '.18em',
              textTransform: 'uppercase', marginBottom: '12px' }}>
              CRÉER UN AGENT PERSONNALISÉ
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              {[
                { key: 'nom', label: 'NOM AGENT', placeholder: 'Ex: NOVA' },
                { key: 'pole', label: 'PÔLE / SECTEUR', placeholder: 'Ex: Immobilier' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.1em',
                    textTransform: 'uppercase', marginBottom: '4px' }}>{f.label}</div>
                  <input
                    value={form[f.key]}
                    onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                    placeholder={f.placeholder}
                    style={{
                      width: '100%', background: '#080808', border: '1px solid #1e1e1e',
                      color: '#e0e0e0', padding: '8px 10px', fontSize: '11px',
                      fontFamily: "'Courier New', monospace", borderRadius: '1px', boxSizing: 'border-box',
                    }}
                  />
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '10px' }}>
              <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.1em',
                textTransform: 'uppercase', marginBottom: '4px' }}>RÔLE MÉTIER</div>
              <input
                value={form.role}
                onChange={e => setForm(prev => ({ ...prev, role: e.target.value }))}
                placeholder="Ex: Spécialiste en estimation immobilière et gestion locative"
                style={{
                  width: '100%', background: '#080808', border: '1px solid #1e1e1e',
                  color: '#e0e0e0', padding: '8px 10px', fontSize: '11px',
                  fontFamily: "'Courier New', monospace", borderRadius: '1px', boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.1em',
                textTransform: 'uppercase', marginBottom: '4px' }}>DESCRIPTION</div>
              <textarea
                value={form.description}
                onChange={e => setForm(prev => ({ ...prev, description: e.target.value }))}
                placeholder="Décrivez les capacités et spécialités de cet agent..."
                rows={3}
                style={{
                  width: '100%', background: '#080808', border: '1px solid #1e1e1e',
                  color: '#e0e0e0', padding: '8px 10px', fontSize: '11px', resize: 'vertical',
                  fontFamily: "'Courier New', monospace", borderRadius: '1px', boxSizing: 'border-box',
                }}
              />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '14px' }}>
              <div>
                <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.1em',
                  textTransform: 'uppercase', marginBottom: '4px' }}>MODÈLE LLM</div>
                <select
                  value={form.llm}
                  onChange={e => setForm(prev => ({ ...prev, llm: e.target.value }))}
                  style={{
                    width: '100%', background: '#080808', border: '1px solid #1e1e1e',
                    color: '#e0e0e0', padding: '8px 10px', fontSize: '11px',
                    fontFamily: "'Courier New', monospace", borderRadius: '1px',
                  }}
                >
                  <option value="gemini-flash">gemini-flash</option>
                  <option value="gemini-dncm">gemini-dncm</option>
                  <option value="gpt-4o-dncm">gpt-4o-dncm</option>
                  <option value="mistral-local">mistral-local</option>
                  <option value="dolphin-local">dolphin-local</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.1em',
                  textTransform: 'uppercase', marginBottom: '4px' }}>
                  TEMPÉRATURE — {form.temp}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', paddingTop: '6px' }}>
                  <span style={{ fontSize: '9px', color: '#444' }}>0.1</span>
                  <input
                    type="range" min="0.1" max="1.0" step="0.05"
                    value={form.temp}
                    onChange={e => setForm(prev => ({ ...prev, temp: e.target.value }))}
                    style={{ flex: 1 }}
                  />
                  <span style={{ fontSize: '9px', color: '#444' }}>1.0</span>
                </div>
              </div>
            </div>

            <button
              onClick={handleGenerate}
              disabled={generating || !form.nom || !form.role}
              style={{
                width: '100%', padding: '11px', background: generating ? '#1a1a1a' : '#ff2222',
                color: generating ? '#444' : '#000', border: 'none', borderRadius: '2px',
                fontSize: '11px', fontWeight: 700, letterSpacing: '.14em', textTransform: 'uppercase',
                cursor: generating ? 'not-allowed' : 'pointer', fontFamily: "'Courier New', monospace",
              }}
            >
              {generating ? '⚡ GÉNÉRATION EN COURS...' : '⚡ GÉNÉRER L\'AGENT'}
            </button>

            {genResult && (
              <div style={{
                marginTop: '12px', padding: '12px', borderRadius: '2px',
                background: genResult.ok ? '#001a0d' : '#1a0000',
                border: `1px solid ${genResult.ok ? '#003d1a' : '#3d0000'}`,
              }}>
                {genResult.ok ? (
                  <div>
                    <div style={{ fontSize: '11px', color: '#00ff88', fontWeight: 700 }}>
                      ✓ AGENT {genResult.persona?.nom} CRÉÉ — ID #{genResult.persona?.id}
                    </div>
                    <div style={{ fontSize: '9px', color: '#555', marginTop: '3px' }}>
                      Modèle: {genResult.model_utilise} · Routing: {genResult.routing}
                    </div>
                  </div>
                ) : (
                  <div style={{ fontSize: '11px', color: '#ff2222' }}>
                    ✕ ERREUR: {genResult.error}
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ONGLET ROUTING */}
        {onglet === 'routing' && (
          <div>
            <div style={{ fontSize: '8px', color: '#ff2222', letterSpacing: '.18em',
              textTransform: 'uppercase', marginBottom: '12px' }}>
              ROUTING LLM — LADDER DNCM
            </div>
            {[
              { level: 'LEVEL 0', llm: 'mistral-local', usage: 'Tâches simples · local · gratuit', color: '#888' },
              { level: 'LEVEL 1', llm: 'gemini-flash', usage: 'Tâches métier · rapide · API', color: '#4488ff' },
              { level: 'LEVEL 2', llm: 'gemini-dncm', usage: 'Analyse complexe · premium', color: '#cc44ff' },
              { level: 'LEVEL 3', llm: 'gpt-4o-dncm', usage: 'Ultra-complexe · coût élevé', color: '#ff8844' },
              { level: 'SECRET', llm: 'dolphin-local', usage: 'Jardin Secret · uncensored', color: '#ff44aa' },
            ].map(r => (
              <div key={r.level} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                background: '#080808', border: '1px solid #1a1a1a',
                padding: '10px 12px', marginBottom: '5px', borderRadius: '2px',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '8px', color: r.color, letterSpacing: '.1em',
                    minWidth: '55px', textTransform: 'uppercase' }}>{r.level}</span>
                  <span style={{ fontSize: '11px', fontWeight: 700, color: '#e0e0e0' }}>{r.llm}</span>
                </div>
                <span style={{ fontSize: '9px', color: '#444' }}>{r.usage}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Footer slogan */}
      <div style={{ padding: '10px 16px', borderTop: '1px solid #1a1a1a',
        fontSize: '9px', color: '#ff2222', letterSpacing: '.1em', textAlign: 'center' }}>
        🛡 Vos données. Votre souveraineté. Méthode DNCM.
      </div>
    </div>
  );
}

// ─── TOKEN BANK ───────────────────────────────────────────────────
function TokenBank({ token }) {
  const [onglet, setOnglet] = useState('comptes');
  const [accountId, setAccountId] = useState('');
  const [balance, setBalance]     = useState(null);
  const [network, setNetwork]     = useState(null);
  const [loading, setLoading]     = useState(false);
  const [msg, setMsg]             = useState(null);

  const [creditForm, setCreditForm]     = useState({ account_id: '', amount: '', description: '' });
  const [transferForm, setTransferForm] = useState({ from_account: '', to_account: '', amount: '', description: '' });

  const accent  = '#ffaa00';
  const accentBg = '#1a1200';
  const accentBorder = '#3d2d00';

  const lookup = async () => {
    if (!accountId.trim()) return;
    setLoading(true); setBalance(null); setNetwork(null); setMsg(null);
    try {
      const [balRes, netRes] = await Promise.all([
        axios.get(`${API}/token/balance/${accountId}`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${API}/token/network/${accountId}`,  { headers: { Authorization: `Bearer ${token}` } }),
      ]);
      setBalance(balRes.data);
      setNetwork(netRes.data);
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.error || e.message });
    } finally { setLoading(false); }
  };

  const handleCredit = async () => {
    if (!creditForm.account_id || !creditForm.amount) return;
    setLoading(true); setMsg(null);
    try {
      const res = await axios.post(`${API}/token/credit`, {
        account_id: creditForm.account_id,
        amount: parseFloat(creditForm.amount),
        description: creditForm.description || 'Crédit admin',
      }, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
      setMsg({ ok: true, text: `✓ ${creditForm.amount} tokens crédités sur ${creditForm.account_id}` });
      setCreditForm({ account_id: '', amount: '', description: '' });
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.error || e.message });
    } finally { setLoading(false); }
  };

  const handleTransfer = async () => {
    if (!transferForm.from_account || !transferForm.to_account || !transferForm.amount) return;
    setLoading(true); setMsg(null);
    try {
      await axios.post(`${API}/token/transfer`, {
        from_account: transferForm.from_account,
        to_account:   transferForm.to_account,
        amount:       parseFloat(transferForm.amount),
        description:  transferForm.description || 'Transfert admin',
      }, { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } });
      setMsg({ ok: true, text: `✓ ${transferForm.amount} tokens transférés ${transferForm.from_account} → ${transferForm.to_account}` });
      setTransferForm({ from_account: '', to_account: '', amount: '', description: '' });
    } catch (e) {
      setMsg({ ok: false, text: e.response?.data?.error || e.message });
    } finally { setLoading(false); }
  };

  const inputStyle = {
    width: '100%', background: '#080808', border: '1px solid #1e1e1e',
    color: '#e0e0e0', padding: '8px 10px', fontSize: '11px',
    fontFamily: "'Courier New', monospace", borderRadius: '1px', boxSizing: 'border-box',
  };

  const labelStyle = {
    fontSize: '8px', color: '#444', letterSpacing: '.1em',
    textTransform: 'uppercase', marginBottom: '4px',
  };

  return (
    <div style={{ background: '#0a0a0a', border: `1px solid ${accentBorder}`, borderRadius: '2px', fontFamily: "'Courier New', monospace" }}>
      {/* Header */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '18px', color: accent }}>◈</span>
          <div>
            <div style={{ fontSize: '13px', fontWeight: 700, color: '#e0e0e0', letterSpacing: '.1em' }}>TOKEN BANK</div>
            <div style={{ fontSize: '9px', color: '#555', letterSpacing: '.08em', textTransform: 'uppercase' }}>Soldes · Crédits · Transferts · Bridge 4030</div>
          </div>
        </div>
        <span style={{ fontSize: '8px', color: accent, background: accentBg, border: `1px solid ${accentBorder}`, padding: '2px 7px', borderRadius: '1px' }}>ADMIN</span>
      </div>

      {/* Onglets */}
      <div style={{ display: 'flex', borderBottom: '1px solid #1a1a1a' }}>
        {['comptes', 'créditer', 'transférer'].map(o => (
          <button key={o} onClick={() => { setOnglet(o); setMsg(null); }} style={{
            padding: '9px 16px', fontSize: '9px', letterSpacing: '.12em', textTransform: 'uppercase',
            background: onglet === o ? accentBg : 'none',
            color: onglet === o ? accent : '#444',
            border: 'none', borderBottom: onglet === o ? `2px solid ${accent}` : '2px solid transparent',
            cursor: 'pointer', fontFamily: "'Courier New', monospace",
          }}>{o}</button>
        ))}
      </div>

      <div style={{ padding: '16px' }}>

        {/* Feedback */}
        {msg && (
          <div style={{ marginBottom: '12px', padding: '10px 12px', borderRadius: '2px',
            background: msg.ok ? '#001a0d' : '#1a0000',
            border: `1px solid ${msg.ok ? '#003d1a' : '#3d0000'}`,
            fontSize: '11px', color: msg.ok ? '#00ff88' : '#ff4444' }}>
            {msg.text}
          </div>
        )}

        {/* COMPTES */}
        {onglet === 'comptes' && (
          <div>
            <div style={{ fontSize: '8px', color: accent, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '12px' }}>
              CONSULTER UN COMPTE
            </div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
              <input value={accountId} onChange={e => setAccountId(e.target.value)}
                placeholder="account_id (ex: dncm-master)"
                onKeyDown={e => e.key === 'Enter' && lookup()}
                style={{ ...inputStyle, flex: 1 }} />
              <button onClick={lookup} disabled={loading} style={{
                padding: '8px 16px', background: loading ? '#1a1a1a' : accent,
                color: loading ? '#444' : '#000', border: 'none', borderRadius: '1px',
                fontSize: '10px', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase',
                cursor: loading ? 'not-allowed' : 'pointer', fontFamily: "'Courier New', monospace", whiteSpace: 'nowrap',
              }}>{loading ? '...' : 'LOOKUP →'}</button>
            </div>

            {balance && (
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '12px' }}>
                  {[
                    { label: 'SOLDE', val: `${balance.balance ?? balance.tokens ?? '—'} TKN` },
                    { label: 'COMPTE', val: balance.account_id || accountId },
                    { label: 'STATUT', val: balance.status || 'ACTIVE' },
                  ].map(item => (
                    <div key={item.label} style={{ background: '#080808', border: '1px solid #1a1a1a', padding: '10px', borderRadius: '2px' }}>
                      <div style={{ fontSize: '8px', color: '#444', letterSpacing: '.12em', textTransform: 'uppercase', marginBottom: '4px' }}>{item.label}</div>
                      <div style={{ fontSize: '13px', color: accent, fontWeight: 700 }}>{item.val}</div>
                    </div>
                  ))}
                </div>

                {network?.agents && network.agents.length > 0 && (
                  <div>
                    <div style={{ fontSize: '8px', color: accent, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '8px' }}>
                      AGENTS LIÉS — {network.agents.length}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                      {network.agents.map(a => (
                        <span key={a} style={{ fontSize: '9px', padding: '3px 8px', borderRadius: '1px', letterSpacing: '.08em',
                          textTransform: 'uppercase', border: `1px solid ${accentBorder}`, color: accent, background: accentBg }}>
                          {a}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* CRÉDITER */}
        {onglet === 'créditer' && (
          <div>
            <div style={{ fontSize: '8px', color: accent, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '12px' }}>
              CRÉDITER UN COMPTE
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              {[
                { key: 'account_id', label: 'ACCOUNT ID', placeholder: 'dncm-master' },
                { key: 'amount',     label: 'MONTANT (tokens)', placeholder: '1000' },
              ].map(f => (
                <div key={f.key}>
                  <div style={labelStyle}>{f.label}</div>
                  <input value={creditForm[f.key]} placeholder={f.placeholder}
                    onChange={e => setCreditForm(p => ({ ...p, [f.key]: e.target.value }))}
                    type={f.key === 'amount' ? 'number' : 'text'} style={inputStyle} />
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '14px' }}>
              <div style={labelStyle}>DESCRIPTION</div>
              <input value={creditForm.description} placeholder="Crédit mensuel Business"
                onChange={e => setCreditForm(p => ({ ...p, description: e.target.value }))}
                style={inputStyle} />
            </div>
            <button onClick={handleCredit} disabled={loading || !creditForm.account_id || !creditForm.amount} style={{
              width: '100%', padding: '11px', background: (loading || !creditForm.account_id || !creditForm.amount) ? '#1a1a1a' : accent,
              color: (loading || !creditForm.account_id || !creditForm.amount) ? '#444' : '#000',
              border: 'none', borderRadius: '2px', fontSize: '11px', fontWeight: 700,
              letterSpacing: '.14em', textTransform: 'uppercase',
              cursor: (loading || !creditForm.account_id || !creditForm.amount) ? 'not-allowed' : 'pointer',
              fontFamily: "'Courier New', monospace",
            }}>
              {loading ? '⚡ EN COURS...' : '⚡ CRÉDITER LE COMPTE'}
            </button>
          </div>
        )}

        {/* TRANSFÉRER */}
        {onglet === 'transférer' && (
          <div>
            <div style={{ fontSize: '8px', color: accent, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '12px' }}>
              TRANSFERT INTER-COMPTES
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px' }}>
              {[
                { key: 'from_account', label: 'DE (source)',       placeholder: 'dncm-master' },
                { key: 'to_account',   label: 'VERS (destination)', placeholder: 'client-001' },
              ].map(f => (
                <div key={f.key}>
                  <div style={labelStyle}>{f.label}</div>
                  <input value={transferForm[f.key]} placeholder={f.placeholder}
                    onChange={e => setTransferForm(p => ({ ...p, [f.key]: e.target.value }))}
                    style={inputStyle} />
                </div>
              ))}
            </div>
            <div style={{ marginBottom: '10px' }}>
              <div style={labelStyle}>MONTANT (tokens)</div>
              <input value={transferForm.amount} placeholder="500" type="number"
                onChange={e => setTransferForm(p => ({ ...p, amount: e.target.value }))}
                style={inputStyle} />
            </div>
            <div style={{ marginBottom: '14px' }}>
              <div style={labelStyle}>DESCRIPTION</div>
              <input value={transferForm.description} placeholder="Allocation mensuelle"
                onChange={e => setTransferForm(p => ({ ...p, description: e.target.value }))}
                style={inputStyle} />
            </div>
            <button onClick={handleTransfer} disabled={loading || !transferForm.from_account || !transferForm.to_account || !transferForm.amount} style={{
              width: '100%', padding: '11px',
              background: (loading || !transferForm.from_account || !transferForm.to_account || !transferForm.amount) ? '#1a1a1a' : accent,
              color:      (loading || !transferForm.from_account || !transferForm.to_account || !transferForm.amount) ? '#444' : '#000',
              border: 'none', borderRadius: '2px', fontSize: '11px', fontWeight: 700,
              letterSpacing: '.14em', textTransform: 'uppercase',
              cursor: (loading || !transferForm.from_account || !transferForm.to_account || !transferForm.amount) ? 'not-allowed' : 'pointer',
              fontFamily: "'Courier New', monospace",
            }}>
              {loading ? '⚡ EN COURS...' : '⚡ EXÉCUTER LE TRANSFERT'}
            </button>
          </div>
        )}
      </div>

      <div style={{ padding: '10px 16px', borderTop: '1px solid #1a1a1a',
        fontSize: '9px', color: accent, letterSpacing: '.1em', textAlign: 'center' }}>
        ◈ Token Bank DNCM · Souveraineté financière des agents
      </div>
    </div>
  );
}

// ─── MODULE PRINCIPAL ─────────────────────────────────────────────
export default function AgentsModule({ token }) {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [vue, setVue] = useState('agents'); // 'agents' | 'miroir'

  const handleCardClick = (agent) => {
    setSelectedAgent(selectedAgent?.id === agent.id ? null : agent);
  };

  const agentsVisibles = AGENTS_DATA.filter(a => !a.adminOnly);
  const actifs = agentsVisibles.filter(a => a.status === 'ACTIVE').length;
  const pending = agentsVisibles.filter(a => a.status === 'PENDING').length;

  return (
    <div style={{ fontFamily: "'Courier New', monospace", color: '#e0e0e0' }}>

      {/* Header section */}
      <div style={{ background: '#0a0a0a', border: '1px solid #1a1a1a', borderLeft: '2px solid #ff2222',
        padding: '16px 20px', marginBottom: '16px', borderRadius: '2px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div style={{ fontSize: '18px', fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase' }}>
            AGENT COMMAND CENTER
          </div>
          <div style={{ fontSize: '10px', color: '#555', marginTop: '3px', letterSpacing: '.08em' }}>
            Tous les systèmes opérationnels · VPS 72.60.233.88
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '9px', color: '#00ff88', background: '#003d1a',
            border: '1px solid #00aa44', padding: '3px 8px', borderRadius: '1px' }}>
            {actifs} ACTIFS
          </span>
          <span style={{ fontSize: '9px', color: '#ffaa00', background: '#1a1200',
            border: '1px solid #3d2d00', padding: '3px 8px', borderRadius: '1px' }}>
            {pending} PENDING
          </span>
        </div>
      </div>

      {/* Toggle vue */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
        {[
          { key: 'agents',      label: '◈ AGENTS MÉTIER' },
          { key: 'miroir',      label: '◐ AGENT MIROIR' },
          { key: 'token-bank',  label: '◈ TOKEN BANK' },
        ].map(v => (
          <button key={v.key} onClick={() => setVue(v.key)} style={{
            padding: '9px 18px', fontSize: '10px', fontWeight: 700, letterSpacing: '.12em',
            textTransform: 'uppercase', borderRadius: '2px', cursor: 'pointer',
            fontFamily: "'Courier New', monospace",
            background: vue === v.key ? '#ff2222' : 'none',
            color: vue === v.key ? '#000' : '#555',
            border: vue === v.key ? 'none' : '1px solid #333',
          }}>{v.label}</button>
        ))}
      </div>

      {/* VUE AGENTS */}
      {vue === 'agents' && (
        <div>
          {/* Section titre */}
          <div style={{ fontSize: '8px', color: '#ff2222', letterSpacing: '.18em', textTransform: 'uppercase',
            marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            AGENTS MÉTIER — {agentsVisibles.length} UNITÉS
            <span style={{ flex: 1, height: '1px', background: '#1a1a1a', display: 'inline-block' }} />
          </div>

          {/* Grille agents rangée 1 — 4 cols */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '10px' }}>
            {agentsVisibles.slice(0, 4).map(agent => (
              <AgentCard
                key={agent.id}
                agent={agent}
                onClick={handleCardClick}
                selected={selectedAgent?.id === agent.id}
              />
            ))}
          </div>

          {/* Grille agents rangée 2 — 3 cols */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
            {agentsVisibles.slice(4).map(agent => (
              <AgentCard
                key={agent.id}
                agent={agent}
                onClick={handleCardClick}
                selected={selectedAgent?.id === agent.id}
              />
            ))}
          </div>

          {/* Panneau détail */}
          {selectedAgent && (
            <AgentDetail agent={selectedAgent} onClose={() => setSelectedAgent(null)} />
          )}
        </div>
      )}

      {/* VUE MIROIR */}
      {vue === 'miroir' && (
        <AgentMiroir token={token} />
      )}

      {/* VUE TOKEN BANK */}
      {vue === 'token-bank' && (
        <TokenBank token={token} />
      )}

      {/* Footer DNCM */}
      <div style={{ marginTop: '24px', background: '#080808', borderTop: '2px solid #ff2222',
        padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '10px' }}>
        <span style={{ fontSize: '10px', color: '#ff2222', letterSpacing: '.1em' }}>
          🛡 Vos données. Votre souveraineté. Méthode DNCM.
        </span>
        <div style={{ display: 'flex', gap: '12px' }}>
          {['Hébergé EU', 'RGPD Conforme', 'JWT Chiffré', 'Tenant Isolé'].map(b => (
            <span key={b} style={{ fontSize: '8px', color: '#444', letterSpacing: '.06em', textTransform: 'uppercase' }}>
              {b}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
